import { GetOrgId } from "utility";

export const TEAMS_SERVICE = (): { GET_ALL_TEAMS_WITH_MEMBERS: string } =>
  ({
    GET_ALL_TEAMS_WITH_MEMBERS: `/api/v1/org/${GetOrgId()}/teams-with-members`,
  } as const);
